import {InjectionToken} from '@angular/core';

export const QC_NUMBER_GROUPS_TOKEN = new InjectionToken<number>(
  'Specification of number of groups',
  {
    providedIn: 'root',
    factory: () => undefined,
  }
);

export const QC_GROUP_SELECTED_TOKEN = new InjectionToken<
  'all' | number | undefined
>('Especify the group of measures to use', {
  providedIn: 'root',
  factory: () => 'all',
});

export const QC_INSPECTION_STAGE_TOKEN = new InjectionToken<
  | undefined
  | 'Quality Control'
  | 'Quality Control Poly Trimming'
  | 'Quality Control Poly Lines'
  | 'Quality Control Visual'
>('Especify the kind of inspection stage to use', {
  providedIn: 'root',
  factory: () => undefined,
});

export const QC_SHOW_QTY_PER_INSPECTION_TOKEN = new InjectionToken<boolean>(
  'Specification of quantity per inspection',
  {
    providedIn: 'root',
    factory: () => undefined,
  }
);
